import { Box, styled } from '@mui/material';
import { spacingTokens } from '../../themes/spacing';

export const DashboardContainer = styled('div')`
  display: flex;
  flex-direction: column;
  position: relative;
  justify-content: flex-start;
  padding-top: 0;
`;

export const DashboardActions = styled('div')<{ disabled?: boolean }>`
  gap: ${spacingTokens.Spacing12};
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  max-width: 1920px;
  box-sizing: border-box;
  pointer-events: ${({ disabled }) => (disabled ? 'none' : 'inherit')};
  opacity: ${({ disabled }) => (disabled ? '0.5' : '1')};
  padding-top: ${spacingTokens.Spacing16};
  padding-bottom: ${spacingTokens.SpacingNone};
  padding-left: ${spacingTokens.Spacing16};
  padding-right: ${spacingTokens.Spacing16};
`;

export const WidgetGrid = styled(Box)<{ minHeight?: string }>`
  width: 100%;
  display: grid;
  box-sizing: border-box;
  grid-template-columns: repeat(4, 1fr);
  gap: ${spacingTokens.Spacing12};
  padding: ${spacingTokens.Spacing16};
  max-width: 1920px;
  @media (max-width: ${({ theme }) => theme.breakpoints.values.lg}px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: ${({ theme }) => theme.breakpoints.values.sm}px) {
    grid-template-columns: repeat(1, 1fr);
  }
`;
export const WidgetGridContainer = styled('div')<{ span: number }>`
  width: 100%;
  grid-column: ${({ span }) => `span ${span}`};
  box-sizing: border-box;
  min-width: ${({ span }) => (span ? `${(span * 100) / 4}%` : `25%`)};
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: center;
  box-sizing: border-box;

  @media (max-width: ${({ theme }) => theme.breakpoints.values.sm}px) {
    grid-column: span 1;
  }
`;
